import { render, staticRenderFns } from "./ChooseDesign.vue?vue&type=template&id=71a8c790&scoped=true&lang=pug&"
import script from "./ChooseDesign.vue?vue&type=script&lang=js&"
export * from "./ChooseDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8c790",
  null
  
)

export default component.exports